import ExtensionIcon from '@material-ui/icons/Extension';
import CrosswordRewardsList from './components/CrosswordRewardsList';
import { APP_TYPES, roles } from '../../../config/constants';

const options = {
  appTypes: [APP_TYPES.HUNGARY, APP_TYPES.IRELAND],
  allowedRoles: [roles.ADMIN],
  label: 'Crossword Rewards',
  subMenuName: 'reports',
};

export default {
  list: CrosswordRewardsList,
  icon: ExtensionIcon,
  name: 'crosswords/rewards',
  options,
};
